/*
 * Wire Monkey — product-page running total.
 * Shows "Total: <qty × unit price>" beside the price, updating live as the
 * quantity changes. Appears only when quantity > 1 so the single-item view stays
 * clean. Additive only — it listens to the theme's existing eventBus events
 * (qty:change, variant:updated) and never modifies the price/variant/cart logic.
 */
(function () {
  'use strict';

  // Standard Shopify money formatter (matches the theme's own helper).
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands,
      );
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  if (customElements.get('wm-quantity-total')) return;

  customElements.define(
    'wm-quantity-total',
    class WmQuantityTotal extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
        // Scope to this product's section so quick-view / other sections don't
        // cross-fire. Derived from the wrapping product-information element.
        this.sectionId =
          this.closest('product-information')?.getAttribute('data-section-id') ||
          null;
        this.output = this.querySelector('[data-line-total]');
        this.quantity = 1;

        this.onQty = this.handleQty.bind(this);
        this.onVariant = this.handleVariant.bind(this);

        // eventBus is a global provided by the theme's eventBus.js.
        if (window.eventBus) {
          window.eventBus.on('qty:change', this.onQty);
          window.eventBus.on('variant:updated', this.onVariant);
        }
        this.render();
      }

      disconnectedCallback() {
        if (window.eventBus) {
          window.eventBus.off('qty:change', this.onQty);
          window.eventBus.off('variant:updated', this.onVariant);
        }
      }

      // Ignore events fired for a different product section (quick view, etc.).
      isForThisSection(detail) {
        return !(
          detail &&
          detail.sectionId &&
          this.sectionId &&
          detail.sectionId !== this.sectionId
        );
      }

      handleQty(detail) {
        if (!this.isForThisSection(detail)) return;
        var qty = parseInt(detail && detail.value, 10);
        this.quantity = isNaN(qty) || qty < 1 ? 1 : qty;
        this.render();
      }

      handleVariant(detail) {
        if (!this.isForThisSection(detail)) return;
        // The theme resets quantity to 1 on variant change.
        this.quantity = 1;
        this.render();
      }

      currentUnitPrice() {
        // Read the current variant's price (in cents) from the price element,
        // which the theme re-renders on variant change.
        var root = this.closest('product-information') || document;
        var priceEl = root.querySelector('[data-unit-price]');
        if (!priceEl) return NaN;
        return parseInt(priceEl.getAttribute('data-unit-price'), 10);
      }

      render() {
        if (!this.output) this.output = this.querySelector('[data-line-total]');
        var unit = this.currentUnitPrice();
        if (isNaN(unit) || this.quantity < 2 || !this.output) {
          this.hidden = true;
          return;
        }
        this.output.textContent = formatMoney(unit * this.quantity, this.moneyFormat);
        this.hidden = false;
      }
    },
  );
})();
